/** baby: Craft website media map. Higgsfield loops + PH craft stickers */

export const CRAFT_MEDIA = {
  heroPoster: '/ninxl/craft/web-hero-diorama.png',
  heroVideo: '/ninxl/craft/vid/craft-hero.mp4',
  studioPoster: '/ninxl/craft/web-studio-vignettes.png',
  studioVideo: '/ninxl/craft/vid/craft-studio.mp4',
  origamiPoster: '/ninxl/craft/craft-origami-accent.png',
  origamiVideo: '/ninxl/craft/vid/craft-origami.mp4',
  atmosphereVideo: '/ninxl/craft/vid/craft-atmosphere.mp4',
  dividerOrnament: '/ninxl/craft/craft-divider-ornament.png',
  kraftTear: '/ninxl/craft/craft-kraft-tear.png',
  icons: {
    video: '/ninxl/craft/icons/icon-video.png',
    mic: '/ninxl/craft/icons/icon-mic.png',
    screen: '/ninxl/craft/icons/icon-screen.png',
    code: '/ninxl/craft/icons/icon-code.png',
    /** baby: Studio stamp — collage style matched to icon-video / icon-code. */
    studio: '/ninxl/craft/icons/icon-studio.png',
    /** baby: Automations stamp — schedule / recurring agentic tasks. */
    automations: '/ninxl/craft/icons/icon-automations.png',
    /** baby: Legacy agentic collage icon (kept for older frames). */
    agentic: '/ninxl/craft/icons/icon-agentic.png',
    /** baby: Rooms stamp — collage style matched to other use-case icons. */
    rooms: '/ninxl/craft/icons/icon-rooms.png',
    offline: '/ninxl/craft/icons/craft-icon-offline.png',
    drive: '/ninxl/craft/icons/craft-icon-drive.png',
    bolt: '/ninxl/craft/icons/craft-icon-bolt.png',
    shield: '/ninxl/craft/icons/craft-icon-shield.png',
    key: '/ninxl/craft/icons/craft-icon-key.png',
    deskAgent: '/ninxl/craft/icons/craft-icon-desk-agent.png',
    inkflow: '/ninxl/craft/icons/craft-icon-inkflow.png',
    crews: '/ninxl/craft/icons/craft-icon-crews.png',
  },
  /** baby: Brand craft stickers for Works In (Gmail, Slack, shell, browser…). */
  brands: {
    gmail: '/ninxl/craft/icons/brands/gmail_craft.png',
    slack: '/ninxl/craft/icons/brands/slack_craft.png',
    whatsapp: '/ninxl/craft/icons/brands/whatsapp_craft.png',
    docs: '/ninxl/craft/icons/brands/docs_craft.png',
    gdocs: '/ninxl/craft/icons/brands/gdocs_craft.png',
    shell: '/ninxl/craft/icons/brands/code_dark_craft.png',
    browser: '/ninxl/craft/icons/brands/browser_craft.png',
    ninx: '/ninxl/craft/icons/brands/ninx-app-icon-craft-clean.png',
  },
  stickers: {
    star: '/ninxl/craft/icons/sticker-star.png',
    kraft: '/ninxl/craft/icons/sticker-kraft.png',
    tape: '/ninxl/craft/icons/sticker-tape.png',
  },
  /** baby: Creation-of-Adam craft cutouts: alpha hands + on-device model chips. */
  adam: {
    handLeft: '/ninxl/craft/adam/hand-left.png',
    handRight: '/ninxl/craft/adam/hand-right.png',
    modelCore: '/ninxl/craft/adam/model-core.png',
    modelWeights: '/ninxl/craft/adam/model-weights.png',
    modelDevice: '/ninxl/craft/adam/model-device.png',
    modelAgent: '/ninxl/craft/adam/model-agent.png',
  },
  /**
   * baby: /nin Namaste cutouts: split from one joined pair so palms touch
   * with zero seam gap at x=0 (opposite scroll direction from Adam).
   */
  namaste: {
    handLeft: '/nin/craft/namaste/hand-left.png',
    handRight: '/nin/craft/namaste/hand-right.png',
    pair: '/nin/craft/namaste/namaste-pair-alpha.png',
  },
} as const
